import axios from 'axios';
import { REQUEST_DATE_PRICE, LOAD_DATE_PRICE, DATE_PRICE_ERROR, SET_SELECTED_DATE } from '../quote';
import { loadErrorMessage } from '../../services/requests';
import { updateCateringMinimumSpend } from './rules';

// The request belongs to the quote, not to the calendar dialog. Its response
// must still commit after the dialog closes, while older attempts stay ignored.
export const requestDatePrice = date => async (dispatch, getState) => {
  const { config, quote } = getState();
  if (!date) return;
  // Keep the existing DST adjustment without accumulating hours on retries or
  // calendar reopen: this is a calendar day, not a customer-selected time.
  const selected = date.clone().startOf('day').add(1, 'h');
  const eventTypeId = quote.eventType.id;
  if (config.hidePricing || !eventTypeId) {
    dispatch({ type: SET_SELECTED_DATE, payload: { date: selected, price: 0, priceStatus: 'ready' } });
    return;
  }
  const requestId = (quote.datePriceRequestId || 0) + 1;
  dispatch({ type: REQUEST_DATE_PRICE, payload: { date: selected, requestId } });
  const isCurrentRequest = () => {
    const current = getState();
    return current.quote.datePriceRequestId === requestId
      && current.quote.eventType.id === eventTypeId
      && current.config.app_id === config.app_id
      && current.config.appUrl === config.appUrl
      && current.config.key === config.key;
  };
  try {
    const response = await axios.get(`${config.appUrl}/api/location/price?location_id=${config.app_id}&hire_from=${date.format('DD-MM-YYYY')}&booking_type_id=${eventTypeId}`,
      { headers: { Accept: 'application/json' } });
    if (!isCurrentRequest()) return;
    const venuePrice = response.data.venue;
    const price = Number(venuePrice);
    if (venuePrice === null || venuePrice === undefined || venuePrice === '' || !Number.isFinite(price)) {
      throw new Error('Invalid hire price');
    }
    dispatch({ type: LOAD_DATE_PRICE, payload: { requestId, eventTypeId, price } });
    dispatch(updateCateringMinimumSpend());
  } catch (error) {
    if (isCurrentRequest()) {
      const message = error.message === 'Invalid hire price'
        ? 'We could not verify the hire price for your date. Please retry.'
        : loadErrorMessage(error, 'the price for your date');
      dispatch({ type: DATE_PRICE_ERROR, payload: { requestId, eventTypeId, message } });
    }
  }
};
